import React, { Component } from 'react';
import { Row, Col, Card, Container } from 'react-bootstrap';
import '../_quiz.scss';
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import moment from 'moment';
import EditQuizTimeModal from './EditQuizTimeModal';
import TableSearchwithStudentResult from '../../questioners/manage_questin_papers/TableSearchwithStudentResult';

class ManageQuizSection extends Component {
    constructor(props) {
        super(props)
        this.state = {
            viewType:"draft",
            modalTimeQuiz:false,
            setTimePaperDetails:"",
            start_time_pop:""

            
        }
        this.onClickEdit = this.onClickEdit.bind(this);
    }

    onClickEdit(paper,type) {
        let item = {}
       
        console.log("pppooo", paper);
        this.props.history.push("/quiz_section/edit_quiz/EditQuizSection", {
            edit: true,
            examDetails: paper,
            globals: this.props.globals,
            editType:type
        });
    }
    handleSelect(val) {
        this.setState({
            viewType: val
        })
    }
    onClickTimeModal = (paper,time_pop) => {
        this.setState({ modalTimeQuiz: true,setTimePaperDetails:paper,start_time_pop:time_pop})
        
    }

    
    tableData = (scheduledQuizExams) => {
        let getArray = [];

        scheduledQuizExams.map(item => {
            item.schedulequiz.map(exams => {
                const newObject = {
                    quiz_name :exams.exam_name,
                    quiz_duration:exams.time_duration,
                    start_time:moment.unix(exams.start_time).format("DD-MM-YYYY LT"),
                    total_students:exams.total_students,
                    edit_paper:<button class="btn btn-primary effect" onClick={() => this.onClickEdit(exams,"normal")}><i class="fas fa-edit"></i> Edit</button>,
                    edit_start_time:<button class="btn btn-primary effect" onClick={() => this.onClickTimeModal(exams,exams.start_time)}><i class="fas fa-edit"></i> Time</button>
                }
                getArray.push(newObject);
            })
        })
        
        return getArray;
    }
    tableData_live = (scheduledQuizExams) => {
        let getArray = [];
        scheduledQuizExams.map(item => {
            item.livequiz.map(exams => {
                const newObject = {
                    quiz_name :exams.exam_name,
                    quiz_duration:exams.time_duration,
                    start_time:moment.unix(exams.start_time).format("DD-MM-YYYY LT"),
                    total_students:exams.total_students,
                    started:exams.started,
                    submitted:exams.submitted_students,
                    not_Started:exams.not_started
                }
                getArray.push(newObject);
            })
        })
        
        return getArray;
    }

    articlecolumns = [
        {
          dataField: "quiz_name",
          text: "Quiz Name",
          sort: true,
        },
        {
          dataField: "quiz_duration",
          text: "Quiz Duration (Min)",
        },
        {
          dataField: "start_time",
          text: "Start Date & Time",
        },
        {
          dataField: "total_students",
          text: "Total Students",
          sort: true,
        },
        {
          dataField: "edit_paper",
          text: "Edit Questions",
          sort: true,
        },
        {
          dataField: "edit_start_time",
          text: "Set Start Time",
          sort: true,
        },
      ];

      articlecolumns_live = [
        {
          dataField: "quiz_name",
          text: "Quiz Name",
          sort: true,
        },
        {
          dataField: "quiz_duration",
          text: "Quiz Duration (Min)",
        },
        {
          dataField: "start_time",
          text: "Start Date & Time",
        },
        {
          dataField: "total_students",
          text: "Total Students",
          sort: true,
        },
        {
          dataField: "started",
          text: "Started",
          sort: true,
        },
        {
            dataField: "submitted",
            text: "Submitted",
            sort: true,
        },
        {
          dataField: "not_Started",
          text: "Not Started",
          sort: true,
        },
      ];

    render() {

        console.log("aravind",this.props.scheduledQuiz)
        return (
            <div className='quiz_section'>
              <div style={{ background: '#fff', borderRadius: 16, boxShadow: '0 4px 24px rgba(0,0,0,0.05)', border: '1px solid #e2e8f0', overflow: 'hidden' }}>
                {/* Header with icon chip + title */}
                <div style={{ display: 'flex', alignItems: 'center', gap: 14, padding: '18px 22px', borderBottom: '1px solid #f1f5f9' }}>
                  <div style={{ background: '#f5f3ff', color: '#7c3aed', borderRadius: 10, width: 40, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16 }}>
                    <i className="fal fa-tasks" />
                  </div>
                  <div>
                    <div style={{ fontWeight: 800, fontSize: 16, color: '#1f2937', letterSpacing: '-0.01em' }}>Manage Quiz</div>
                    <div style={{ fontSize: 12, color: '#6b7280', marginTop: 2 }}>Drafts, scheduled, and live quizzes</div>
                  </div>
                </div>

                <div style={{ padding: '18px 22px' }}>
              <Row>
                  <Col sm={12}>
                      <ul className='list-inline question_sel_cls'>
                        <li  className={this.state.viewType == "draft" ? "active mr-4" : "mr-4"} onClick={() => this.handleSelect("draft")}>Draft Quiz Exams</li>
                        <li className={this.state.viewType == "scheduled" ? "active mr-4" : "mr-4"} onClick={() => this.handleSelect("scheduled")}>Scheduled Quiz Exams</li>
                        <li className={this.state.viewType == "live" ? "active mr-4" : "mr-4"} onClick={() => this.handleSelect("live")}>Live Quiz Exams</li>
                      </ul>
                  </Col>


                  {
                           this.state.viewType === "draft" ?
                            
                             <Col sm={12}>
                                <Card as={Card.Body} className="p-3">
                                    <h4 className="text-center">Draft Quiz Exams</h4>
                                    {
                                        this.props.savedPapers == undefined ?
                                        (<Col>
                                            <div class="spinner-border text-primary text-center loading-img-center"></div>
                                        </Col>) :
                                        (
                                            <div className="table-responsive mt-2">
                                                <table className="table table-bordered table_custom_cls">
                                                    <thead>
                                                        <tr>
                                                            <th>Quiz Name</th>
                                                        {/*<th>Subject</th>*/}
                                                            <th>No.Of.Questions</th>
                                                           {/* <th>Branch</th>*/}
                                                            <th>Class</th>
                                                            <th>Section</th>
                                                            <th>Date & Time</th>
                                                            <th>Edit Questions</th>
                                                            <th>Set Start Time</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                    {this.props.savedPapers.map(paper => (

                                                        <tr>
                                                            <td>{paper.name}</td>
                                                            <td>{paper.total_question_count}</td>
                                                           {/* <td>{paper.branch}</td>*/}
                                                            <td>{paper.class}</td>
                                                            <td>{paper.section}</td>
                                                            <td>{moment.unix(paper.timestamp).format("DD-MM-YYYY LT")}</td>
                                                            <td><button class="btn btn-primary effect" onClick={() => this.onClickEdit(paper,"draft")}><i class="fas fa-edit"></i> Edit</button></td>
                                                            <td><button class="btn btn-primary effect" onClick={() => this.onClickTimeModal(paper,paper.timestamp)}><i class="fas fa-clock"></i> Time</button></td>

                                                        </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        )
                                    }
                                       
                                </Card>
                             </Col>

                            : this.state.viewType === "scheduled" ?
                                <Col sm={12}>
                                    <Card as={Card.Body} className="p-3">
                                        <h4 className="text-center mb-4">Scheduled Quiz Exams</h4>
                                        {
                                            this.props.scheduledQuiz == undefined ?
                                            (<Col>
                                                <div class="spinner-border text-primary text-center loading-img-center"></div>
                                            </Col>) :
                                            (
                                                this.props.scheduledQuiz.map(item => 
                                                    item.schedulequiz.length>0 ?
                                                    (
                                                        <TableSearchwithStudentResult
                                                            parentData={this.tableData(this.props.scheduledQuiz)}
                                                            particlecolumns={this.articlecolumns}
                                                        />
                                                    )
                                                    :
                                                    (<h6 className="text-center">No Scheduled Quiz Exams</h6>)
                                                )
                                            )
                                        }
                                        
                                    </Card>
                                </Col>
                            : this.state.viewType === "live"  ?
                                <Col sm={12}>
                                    <Card as={Card.Body} className="p-3">
                                        <h4 className="text-center mb-4">Live Quiz Exams</h4>
                                        {
                                            this.props.scheduledQuiz == undefined ?
                                            (<Col>
                                                <div class="spinner-border text-primary text-center loading-img-center"></div>
                                            </Col>) :
                                            (
                                                (
                                                    this.props.scheduledQuiz.map(item => 
                                                        item.livequiz.length>0 ?
                                                        (
                                                            <TableSearchwithStudentResult
                                                                parentData={this.tableData_live(this.props.scheduledQuiz)}
                                                                particlecolumns={this.articlecolumns_live}
                                                            />
                                                        )
                                                        :
                                                        (<h6 className="text-center">No Live Quiz Exams</h6>)
                                                    )
                                                )
                                            )
                                        }
                                        
                                    </Card>
                                </Col>
                             : ""
                            
                            
                    }
                    
              </Row>
                </div>
              </div>
              <EditQuizTimeModal
                    setTimePaperDetails={this.state.setTimePaperDetails}
                    show={this.state.modalTimeQuiz}
                    onHide={() => this.setState({ modalTimeQuiz: false})}
                    start_time_pop={this.state.start_time_pop}
                />
              
              </div>
        )
    }
}


export default withRouter(ManageQuizSection);
   


